export default "__VITE_ASSET__JJglIkNu__"